export class ConstantsKeys {
    static defaultLimit: number = 40;
    static defaultHeightGarbage: number = 50;
    static safetyTimeSearch: number = 90 * 1000;
    static defaultLimitInputSearch: number = 1;
    static defaultNewLimitInputSearch: number = 2;
    static visibleButtonDeleteMessageInMinutes: number = 14;
    static visibleButtonEditMessageInMinutes: number = 14;
    static notificationTagCompany: string = 'companyId';
    static notificationTagSector: string = 'sectorId';
    static version: string = '2.3.4';
    static limitUploadFile: number = 16;
    static lastUsedReactions: string = 'lastUsedReactions';
    static activePage: string = 'activePage';
    static localStorageFilters: string = 'localStorageFilters';
    static dateParams: string = 'dateParams';
    static comparativeDateParams: string = 'comparativeDateParams';
    static filterTicketsDateParams: string = 'filterTicketsDateParams';
    static permitReadChatRules: string = 'readChatRules';
    static soundNewMessageChat: string = 'soundNewMessageChat';
    static soundNewMessageInternalChat: string = 'soundNewMessageInternalChat';
    static soundQueueWaitingChat: string = 'soundQueueWaitingChat';
    static defaultLimitListPlans: number = 50;
    static defaultPlanUserMultiplier: number = 1;
    static deadlineToGenerateBillingInDays: number = 7;
    static compactModeMessages: string = 'compactModeMessages';
    static draftMessageCache: string = 'draftMessageCache';
    static blockUpdateLocalSearchCache: string = 'blockUpdateLocalSearchCache';
    static emailQueueDropDesk: string = 'queue@dropdesk.com';
    static minuteInSeconds: number = 60;
    static assistantVirtualName: string = 'Assitente Virtual';
    static isReconnectSubscription: string = 'isReconnectSubscription';
    static limitToReconnectSubscriptionChatInMinutes: number = 58;
    static autoFillDataLocalStorage: string = 'autoFillDataLocalStorage';
    static defaultDataFormTicket: string = 'defaultDataFormTicket';
    static listOnlySectorEmpty: string = 'listOnlySectorEmpty';
    static limitReconnectionAttemptsSocket: number = 60;
    static widthMobile: number = 500;
    static lastJuridicalNatureUsed = 'lastJuridicalNatureUsed';
    static defaultLimitSelectSearchItems = 15;
    static heightFilterApplied = 64;
    static tourListTickets = 'tourListTickets';
    static tourListTicketsNews = 'tourListTicketsNews';
    static fixedTicketFilters = 'fixedTicketFilters';
    static isNewRegister = 'new';
    static chatMessagesV2Limit: number = 20;
}

export class ConstantsStyles {
    static buttonMainFontSize = 16;
    static buttonSaveFontSize = 14;
    static radiusButton = 5;
    static inputFontSize = 15;
    static titleLargeFontSize = 20;
    static defaultLabel = 14;
}
